import { DATE_FORMAT } from "@mostrans/web-components/constants/dateFormat";
import { strMatch } from "@mostrans/web-components/helpers/generalHelpers";
import { orderBy } from "lodash";
import { useCallback, useMemo } from 'react';
import { useGlobalFilter } from '../../shared/hooks/useGlobalFilter';
import { useGetMasterTestimoni } from './useGetMasterTestimoni';

export const useGetMasterTestimoniWithFilter = () => {
    const { globalFilter } = useGlobalFilter()
    const [dataTestimoni, refetch] = useGetMasterTestimoni({
        startDate: globalFilter.startDate.format(DATE_FORMAT.databaseDateOnly),
        endDate: globalFilter.endDate.format(DATE_FORMAT.databaseDateOnly),
    })


    const refetchOnchange = useCallback(() => {
        return refetch()
    }, [refetch, globalFilter.startDate, globalFilter.endDate])

    const orderedTestimoni = useMemo(() => {
        return orderBy(dataTestimoni.data, (dt) => +dt.id, "desc")
    }, [dataTestimoni.data])

    const filteredTestimoni = useMemo(() => {
        return orderedTestimoni?.filter((testi) => {
            if (
                globalFilter.search &&
                !strMatch(
                    globalFilter.search,
                    `${testi.testimony}_${testi?.karyawan?.employee_name}`
                )
            ) {
                return false;
            }
            return true
        })

    }, [globalFilter, dataTestimoni.data])
    return { dataTestimoni, refetch, refetchOnchange, filteredTestimoni }
}
